import styled from 'styled-components';

const StyledPrivateSale1 = styled.section`
    max-width: 1440px;
    padding: 50px 40px;

    h3 {
        font-size: 24px;
        font-weight: 700;
        line-height: 44px;
        margin-bottom: 40px;
        text-align: center;
        text-transform: uppercase;
    }

    .btn {
        padding: 15px 50px;
    }
`;

export default StyledPrivateSale1;
